const USERSVIEW = {
  listUsers: "Lista de usuario",
  updateUser: "Actualizar usuario",
  newUser: "Nuevo usuario",
  search: "Buscar",
  headTable: {
    user: "Usuario",
    email: "Email",
    phone: "Teléfono",
    company: "Compañía",
    rol: "Rol",
    state: "Estado",
    actions: "Acciones"
  },
  dropdowm: {
    update: "Actualizar",
    all: "Todos",
    active: "Activos",
    inactive: "Inactivos",
    eliminated: "Eliminados"
  },
  confirmActive: {
    title: "Confirmación",
    text: `Desea activar el usuario {name} {lastname}`
  },
  deleteUser: {
    title: `Eliminar Usuario: {email}`,
    text: `Confirma que desea eliminar el usuario?`,
    acceptText: "Aceptar",
    cancelText: "Cancelar"
  },
  deleteItemError: {
    title: "Eliminar Usuarios",
    text: "Ocurrio un error, al eliminar el usuario",
    acceptText: "Aceptar",
    cancelText: "Cancelar"
  },
  state: {
    active: "Activo",
    inactive: "Inactivo",
    removed: "Eliminado",
    Active: "Activo",
    Inactive: "Inactivo"
  },

  formEditUser: {
    name: "Nombres",
    lastName: "Apellidos",
    email: "Email de contacto",
    address: "Dirección",
    rol: "rol",
    deparment: "Departamento",
    city: "Ciudad",
    company: "Compañía",
    languages: "Idioma (locale)",
    password: "password",
    repeatPass: "Repita el password",
    status: "Status"
  },
  btn: {
    clean: "Limpiar",
    create: "Crear",
    update: "Actualizar"
  },
  assignForm: {
    title: "Asignar Formularios",
    name: "Nombre/Actividad",
    type: "Tipo",
    group: "Grupo",
    created: "Creado",
    state: "Estado"
  },
  BOT: {
    searchBot: "Buscar formulario bot...",
    searchUser: "Buscar usuario",
    title: "Formularios",
    selectAll: "Seleccionar todo",
    created: "Creado",
    titleNotify: "Asignación",
    message1: "Se han asignado los formularios al(os) usuario(s)",
    messageError: "Error de asignación de formularios"
  }
};

export default { USERSVIEW };
